import {
    USER_LOGIN_REQUEST,
    USER_LOGIN_SUCCESS,
    USER_LOGOUT,
    USER_LOGIN_FAIL,

    USER_REGISTER_REQUEST,
    USER_REGISTER_SUCCESS,
    USER_REGISTER_FAIL,

    USER_DETAILS_REQUEST,
    USER_DETAILS_SUCCESS,
    USER_DETAILS_FAIL,
    USER_DETAILS_RESET,

    USER_UPDATE_PROFILE_REQUEST,
    USER_UPDATE_PROFILE_SUCCESS,
    USER_UPDATE_PROFILE_FAIL,


} from '../constants/userConstants'

import { ORDER_LIST_MY_RESET } from '../constants/orderConstants'
import { BASE_URL } from '../constants/urlConstants'
import axios from 'axios'
import axiosInstance from '../utils/axiosInstance'

export const userLoginAction = (email, password) => async (dispatch) => {
    try {
        dispatch({
            type: USER_LOGIN_REQUEST,
        })

        const config = {// request setting
            header: {
                'Content-type': 'aplication/json'
            }
        }
        const { data } = await axios.post(//send request login
            `${BASE_URL}/users/login/`,
            { 'username': email, 'password': password },
            config,
        )
        dispatch({//user login success
            type: USER_LOGIN_SUCCESS,
            payload: data
        })

        localStorage.setItem(// save information in localstorage
            'userInfo',
            JSON.stringify(data))

    } catch (error) {
        dispatch({//user login fail
            type: USER_LOGIN_FAIL,
            payload: error.response && error.response.data.detail
                ? error.response.data.detail
                : error.message
        })
    }
}


export const userLogoutAction = () => (dispatch) => {
    localStorage.removeItem('userInfo')
    dispatch({ type: USER_LOGOUT })
    dispatch({ type: USER_DETAILS_RESET })
    dispatch({ type: ORDER_LIST_MY_RESET })
}


export const userRegisterAction = (name, email, password) => async (dispatch) => {

    try {
        dispatch({
            type: USER_REGISTER_REQUEST,
        })
        const config = {// request setting
            header: {
                'Content-type': 'aplication/json'
            }
        }
        const { data } = await axios.post(//send request register
            `${BASE_URL}/users/register/`,
            { 'name': name, 'email': email, 'password': password },
            config,
        )

        dispatch({//USER_REGISTER_SUCCESS
            type: USER_REGISTER_SUCCESS,
            payload: data
        })


    } catch (error) {
        dispatch({//user register fail
            type: USER_REGISTER_FAIL,
            payload: error.response && error.response.data.detail
                ? error.response.data.detail
                : error.message
        })
    }

}


export const getUserDetailsAction = (id) => async (dispatch, getState) => {
    try {
        dispatch({
            type: USER_DETAILS_REQUEST
        })

        const { userLogin: { userInfo } } = getState()

        //id can be string as 'profile' also a number'profile number'

        const authRequestAxios = axiosInstance(userInfo, dispatch)
        const { data } = await authRequestAxios.get(`${BASE_URL}/users/${id}`,)
        dispatch(
            {
                type: USER_DETAILS_SUCCESS,
                payload: data
            }
        )
    } catch (error) {
        dispatch({//user details fail
            type: USER_DETAILS_FAIL,
            payload: error.response && error.response.data.detail
                ? error.response.data.detail
                : error.message
        })

    }
}


export const updateUserProfileAction = (user) => async (dispatch, getState) => {

    try {
        dispatch({
            type: USER_UPDATE_PROFILE_REQUEST
        })
        const { userLogin: { userInfo } } = getState()

        const authRequestAxios = axiosInstance(userInfo, dispatch)
        const { data } = await authRequestAxios.put(
            `${BASE_URL}/users/profile/update/`,
            user,
        )
        userInfo.name = data.name
        dispatch({
            type: USER_UPDATE_PROFILE_SUCCESS,
            payload: userInfo
        })
        dispatch({
            type: USER_LOGIN_SUCCESS,
            payload: userInfo
        })

        localStorage.setItem('userInfo', JSON.stringify(data))

    } catch (error) {
        dispatch({//user update profile fail
            type: USER_UPDATE_PROFILE_FAIL,
            payload: error.response && error.response.data.detail
                ? error.response.data.detail
                : error.message
        })
    }

}


export const updateAccessToken = (obj) => (dispatch, getState) => {
    const { userLogin: { userInfo } } = getState()

    userInfo.access = obj.access
    userInfo.refresh = obj.refresh

    dispatch({ type: USER_LOGIN_SUCCESS, payload: userInfo })
    localStorage.setItem('userInfo', JSON.stringify(userInfo))

}